<template>
    <div>
        <br />
        <p style="color: rgb(78, 145, 187); font-weight: bold; font-size: larger; font-family:Microsoft YaHei">
            社会保険の届出において、業務流れと出せるPDFサンプル</p>
        <el-row :gutter=40>
            <el-col :md=16>
                <div style="width: 55vw;text-align: left;">
                    <el-timeline>
                        <el-timeline-item>
                            <p>事業所を設立し、健康保険・厚生年金保険の適用を受けようとするとき</p>
                            <el-card>
                                <el-collapse accordion>
                                    <el-collapse-item name="雇用保険　事業所">
                                        <template slot="title">
                                            事業所を設立
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('/HealthIns1')">
                                                    {{$t('router.health.HealthIns1')}}
                                                </el-link>
                                            </li>
                                        </ul>
                                    </el-collapse-item>
                                </el-collapse>
                            </el-card>
                        </el-timeline-item>
                        <el-timeline-item>
                            <p>従業員を採用したとき</p>
                            <el-card>
                                <el-collapse accordion>
                                    <el-collapse-item name="関連書類">
                                        <template slot="title">
                                            従業員を採用
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('/HealthIns3')">
                                                    {{$t('router.health.HealthIns3')}}
                                                </el-link>
                                            </li>
                                            <li>
                                                <el-link @click="jump('/HealthIns4')">
                                                    {{$t('router.health.HealthIns4')}}
                                                </el-link>
                                            </li>
                                        </ul>
                                    </el-collapse-item>
                                </el-collapse>
                            </el-card>
                        </el-timeline-item>
                        <el-timeline-item>
                            <p>家族を被扶養者にするとき、被扶養者となっている家族に異動があったとき、被扶養者の届出事項に変更があったとき</p>
                            <el-card>
                                <el-collapse accordion>
                                    <el-collapse-item name="関連書類">
                                        <template slot="title">
                                            関連書類
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('/HealthIns5')">
                                                    {{$t('router.health.HealthIns5')}}
                                                </el-link>
                                            </li>
                                        </ul>
                                    </el-collapse-item>
                                </el-collapse>
                            </el-card>
                        </el-timeline-item>
                        <el-timeline-item>
                            <p>被保険者の住所、氏名に変更があったとき</p>
                            <el-card>
                                <el-collapse accordion>
                                    <el-collapse-item name="雇用保険　事業所">
                                        <template slot="title">
                                            関連書類
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('/HealthIns2')">
                                                    {{$t('router.health.HealthIns2')}}
                                                </el-link>
                                            </li>
                                        </ul>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('/InsQualifyNotice')">
                                                    健康保険・厚生年金保険　被保険者氏名変更（訂正）届
                                                </el-link>
                                            </li>
                                        </ul>
                                    </el-collapse-item>
                                </el-collapse>
                            </el-card>
                        </el-timeline-item>
                        <el-timeline-item>
                            <p>従業員が退職、死亡したとき</p>
                            <el-card>
                                <el-collapse accordion>
                                    <el-collapse-item name="関連書類">
                                        <template slot="title">
                                            関連書類
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('/HealthIns3')">
                                                    {{$t('router.health.HealthIns3')}}
                                                </el-link>
                                            </li>
                                            <li>
                                                <el-link @click="jump('/HealthIns4')">
                                                    {{$t('router.health.HealthIns4')}}
                                                </el-link>
                                            </li>
                                        </ul>
                                    </el-collapse-item>
                                </el-collapse>
                            </el-card>
                        </el-timeline-item>
                        <el-timeline-item>
                            <p>適用事業所が廃止、休止等により適用事業所に該当しなくなったとき</p>
                            <el-card>
                                <el-collapse accordion>
                                    <el-collapse-item name="関連書類">
                                        <template slot="title">
                                            関連書類
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('/SuspensionNotice')">
                                                    {{$t('router.health.SuspensionNotice')}}
                                                </el-link>
                                            </li>
                                        </ul>
                                    </el-collapse-item>
                                </el-collapse>
                            </el-card>
                        </el-timeline-item>
                        <el-timeline-item>
                            <p>その他届</p>
                            <el-card>
                                <el-collapse accordion>
                                    <el-collapse-item name="関連書類">
                                        <template slot="title">
                                            関連書類
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('/InsQualifyNotice')">
                                                    {{$t('router.health.InsQualifyNotice')}}
                                                </el-link>
                                            </li>
                                        </ul>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('/PensionReissue')">
                                                    {{$t('router.social.pension_reissue')}}
                                                </el-link>
                                            </li>
                                        </ul>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('/AttoneryPower')">
                                                    {{$t('router.social.attorney_power')}}
                                                </el-link>
                                            </li>
                                        </ul>
                                    </el-collapse-item>
                                </el-collapse>
                            </el-card>
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    export default {
        data() {
            return {};
        },
        methods: {
            jump(path) {
                this.$router.push(path);
            },
        },
    };
</script>

<style scoped>
    .el-row {
        margin-bottom: 20px;
    }

    .el-col {
        border-radius: 4px;
    }

    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }

    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }
</style>


// WEBPACK FOOTER //
// src/components/SocialIns/SocialInsSteps.vue